<div class="bg-white rounded-lg shadow-sm p-4">
  <!-- Toolbar: busqueda + boton agregar -->
  <div class="data-table-toolbar">
    @if (searchable) {
      <div class="data-table-search">
        <nz-input-group [nzSuffix]="searchIcon" nzSize="default">
          <input
            nz-input
            type="text"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearch()"
            [placeholder]="searchPlaceholder"
          />
        </nz-input-group>
        <ng-template #searchIcon>
          @if (searchText) {
            <span
              nz-icon
              nzType="close-circle"
              nzTheme="fill"
              class="search-clear"
              (click)="clearSearch()"
            ></span>
          } @else {
            <span nz-icon nzType="search"></span>
          }
        </ng-template>
      </div>
    }
    <div class="data-table-actions">
      @if (showRefreshButton) {
        <button
          type="button"
          class="btn-refresh-circle"
          nz-tooltip
          nzTooltipTitle="Refrescar"
          aria-label="Refrescar"
          (click)="refresh.emit()"
        >
          <span nz-icon nzType="reload" nzTheme="outline"></span>
        </button>
      }
      @if (showAddButton) {
        <button
          type="button"
          class="btn-add-circle"
          [disabled]="disableAddButton"
          nz-tooltip
          [nzTooltipTitle]="addButtonTooltip"
          aria-label="Agregar"
          (click)="add.emit()"
        >
          <span nz-icon nzType="plus" nzTheme="outline"></span>
        </button>
      }
    </div>
  </div>

  <!-- Tabla -->
  <nz-spin [nzSpinning]="loading" nzTip="Cargando...">
    <nz-table
      #dataTable
      [nzData]="paginatedData"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
      [nzNoResult]="paginatedData.length === 0 && searchText ? customEmptyTpl : undefined"
      nzBordered
      [nzSize]="tableSize"
      nzResize
      class="sinay-headfx"
    >
      <thead>
        <tr>
          @for (col of columns; track col.key) {
            <th
              [style.min-width]="col.minWidth ?? null"
              [nzAlign]="col.align ?? 'left'"
              [class.sortable]="col.sortable"
              (click)="onSort(col)"
              nzResize
            >
              {{ col.header }}
              @if (col.sortable) {
                @if (sortKey === col.key && sortOrder === 'ascend') {
                  <span nz-icon nzType="caret-up" class="sort-icon active"></span>
                } @else if (sortKey === col.key && sortOrder === 'descend') {
                  <span nz-icon nzType="caret-down" class="sort-icon active"></span>
                } @else {
                  <span nz-icon nzType="caret-up" class="sort-icon"></span>
                }
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of dataTable.data; track $index) {
          <tr (click)="onRowClick(row)">
            @for (col of columns; track col.key) {
              <td [nzAlign]="col.align ?? 'left'">
                <!-- Custom template -->
                @if (col.type === 'custom' && getCellTemplate(col.key)) {
                  <ng-container
                    *ngTemplateOutlet="getCellTemplate(col.key)!; context: { $implicit: row, column: col }"
                  ></ng-container>
                }
                <!-- Tag -->
                @else if (col.type === 'tag') {
                  @let tagColor = col.tagColorFn ? col.tagColorFn(getNestedValue(row, col.key), row) : 'default';
                  <nz-tag
                    [nzColor]="tagColor.startsWith('#') ? undefined : tagColor"
                    [style.background-color]="tagColor.startsWith('#') ? 'color-mix(in srgb, ' + tagColor + ' 15%, white)' : null"
                    [style.border-color]="tagColor.startsWith('#') ? tagColor : null"
                    [style.color]="tagColor.startsWith('#') ? tagColor : null"
                    class="block w-full text-center !rounded-full">
                    {{ getNestedValue(row, col.key) }}
                  </nz-tag>
                }
                <!-- Date -->
                @else if (col.type === 'date') {
                  {{ getNestedValue(row, col.key) | date:(col.dateFormat ?? 'dd/MM/yyyy') }}
                }
                <!-- Currency -->
                @else if (col.type === 'currency') {
                  {{ getNestedValue(row, col.key) | currency:(col.currencyCode ?? 'MXN'):'symbol':'1.2-2' }}
                }
                <!-- Boolean -->
                @else if (col.type === 'boolean') {
                  @if (getNestedValue(row, col.key)) {
                    <span nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></span>
                  } @else {
                    <span nz-icon nzType="close-circle" nzTheme="twotone" [nzTwotoneColor]="'#ff4d4f'"></span>
                  }
                }
                <!-- Status -->
                @else if (col.type === 'status') {
                  @let val = getNestedValue(row, col.key);
                  <div class="status-indicator">
                    @if (val === true || val?.toString().toLowerCase().includes('activ')) {
                      <div class="status-dot status-active"
                           nz-tooltip
                           [nzTooltipTitle]="val === true ? 'Activo' : (val || 'N/A')"></div>
                    } @else {
                      <div class="status-dot status-inactive"
                           nz-tooltip
                           [nzTooltipTitle]="val === false ? 'Inactivo' : (val || 'N/A')"></div>
                    }
                  </div>
                }
                <!-- Text (default) -->
                @else {
                  {{ getNestedValue(row, col.key) }}
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </nz-table>
  </nz-spin>

  <!-- Paginacion manual -->
  @if (totalFiltered > 0) {
    <div class="data-table-pagination">
      <span class="pagination-info">
        {{ (pageIndex - 1) * pageSize + 1 }}-{{ pageIndex * pageSize > totalFiltered ? totalFiltered : pageIndex * pageSize }}
        de {{ totalFiltered }}
      </span>
      <nz-table
        #paginationTable
        [nzData]="filteredData"
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="pageSizeOptions.length > 1"
        [nzPageSizeOptions]="pageSizeOptions"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [nzShowTotal]="totalTemplate"
        nzSize="small"
        class="pagination-only"
      ></nz-table>
      <ng-template #totalTemplate></ng-template>
    </div>
  }

  <ng-template #customEmptyTpl>
    <nz-empty [nzNotFoundContent]="customEmptyContent"></nz-empty>
    <ng-template #customEmptyContent>
      <span>No se encontro informacion con los filtros aplicados</span>
      <br>
      <a (click)="clearSearch()">Limpiar filtros</a>
    </ng-template>
  </ng-template>
</div>
